module.exports = __webpack_public_path__ + "static/media/C-100HD_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/de/C-100HD_CrossSection.png
// module id = 466
// module chunks = 0